import { createRouter, createWebHistory, RouteRecordRaw, createWebHashHistory } from 'vue-router';
import NotFound from '@/entrys/404/index.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: '管理后台登录',
      /** 不需要登录即可访问，见 isPublicRoute */
      public: true
    },
    component: () => import("@/entrys/login/index.vue")
  },
  {
    path: '/register',
    name: 'register',
    component: () => import("@/entrys/register/index.vue"),
    meta: {
      title: '管理后台注册',
      public: true
    },
  },
  {
    path: '/forgot',
    name: 'forgot',
    component: () => import("@/entrys/forgot/index.vue"),
    meta: {
      title: '管理后台找回密码',
      public: true
    },
  },
  {
    path: "/home",
    component: () => import("@/entrys/home/index.vue"),
    meta: {
      title: '选择店铺',
      auth: true
    },
  }
]

const router = createRouter({
  history: process.env.VUE_APP_NODE_ENV == 'production' ? createWebHistory(process.env.BASE_URL) : createWebHistory(process.env.BASE_URL),
  routes
})

/**
 * 不用登录就能进的页面（登录 / 注册 / 找回密码）。
 *
 * 判定读路由上标的 meta.public，而不是拿 to.path 去比一个字符串数组：
 * 字符串要一字不差才匹配得上，「/forgot/」这种带尾斜杠的会漏掉，
 * 然后被当成「没登录」弹回登录页
 * */
function isPublicRoute(to: any) {
  return to?.meta?.public === true;
}

let isFirst = true;

let loopEvent = (list) => {
  return list.map((item) => {
    if (item.children) {
      let redirect;
      if (item.redirect) {
        if (item.children[0].aliasName) {
          redirect = {
            name: item.children[0].aliasName
          };
        } else if (item.children[0]?.children) {
          redirect = {
            name: item.children[0]?.children[0]?.aliasName
          };
        }
      }
      let groupArrayList = []
      if (item.isGroup) {
        loopEvent(item.children).map((citem) => {
          if (citem.children) {
            groupArrayList.push(...citem.children)
          }
        });
      }
      return {
        redirect,
        meta: { ...item.meta, isMenu: item.show },
        name: item.aliasName,
        component: () => item.filePath ? import(`@/views/${item.filePath}`) : import("@/views/common/empty.vue"),
        path: item.path,
        children: item.isGroup ? groupArrayList : loopEvent(item.children)
      };
    }
    return {
      meta: { ...item.meta, isMenu: item.show },
      name: item.aliasName,
      component: () => item.filePath ? import(`@/views/${item.filePath}`) : import("@/views/common/empty.vue"),
      path: item.path,
    };
  })
};

router.beforeEach(async (to, from, next) => {
  let store = (await import('@/store')).default;
  const token = store?.state['user']?.token;
  if (isPublicRoute(to)) {
    return next()
  }
  if (!token) {
    return next({
      path: '/login'
    });
  }

  if (to.matched.length === 0 && isFirst) {
    let { error, data } = await store.dispatch('store/getLastMenu');
    if (error) {
      return next("/home")
    }
    isFirst = false;
    let list = loopEvent(data.list);
    router.addRoute({
      name: "index",
      path: "/",
      component: () => import("@/entrys/index/index.vue"),
      redirect: { name: list[0].name },
      children: list,
      meta: {
        auth: true
      },
    });
    router.addRoute({
      path: "/:pathMatch(.*)",
      component: NotFound
    });
    return next(to);
  }
  return next();
});

router.afterEach(async (to, from) => {
  let title = `${to.meta?.title || ''}`;
  /**
   * 公开页面不能去拉店铺信息：这时候没有 token，接口回 100000「用户未登录」，
   * 而 API 层把 100000 当成登录过期，直接触发 user/logout → replace('/login')。
   * 结果就是刷新 /forgot 或 /register 会被弹回登录页 —— beforeEach 明明是放行的，
   * 一直是这里在把用户拽走（顺带在登录页也刷一次「登录过期」的提示）
   * */
  if (isPublicRoute(to)) {
    document.title = title ? [title, '知之网络'].join("-") : '知之网络';
    return;
  }
  let store = (await import('@/store')).default;
  await store.dispatch("store/getLastStore")
  if (store.state['store']?.store?.name) {
    document.title = title ? [title, store.state['store']?.store?.name].join("-") : store.state['store']?.store?.name;
    return;
  }
  document.title = title ? [title, '知之网络'].join("-") : '知之网络';
})
export default router;